import { render, staticRenderFns } from "./FooterCategories.vue?vue&type=template&id=c448f37e&scoped=true&"
import script from "./FooterCategories.vue?vue&type=script&lang=js&"
export * from "./FooterCategories.vue?vue&type=script&lang=js&"
import style0 from "./FooterCategories.vue?vue&type=style&index=0&id=c448f37e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c448f37e",
  null
  
)

export default component.exports